"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Typography = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
/**
 * @internal
 */
exports.Typography = function (props) {
    var Tag = props.tagName, children = props.children, className = props.className, title = props.title, onClick = props.onClick;
    return (react_1.default.createElement(Tag, { className: classnames_1.default("gd-typography", "gd-typography--" + Tag, className), onClick: onClick, title: title }, children));
};
//# sourceMappingURL=Typography.js.map